import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  id: "testimonials",
  class: "testimonials"
}
const _hoisted_2 = { class: "testimonials__container container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "testimonials__title" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "testimonials__title--h2" }, " Testimonios "),
  /*#__PURE__*/_createElementVNode("p", { class: "testimonials__title--p" }, " lo que nuestros clientes dicen de nosotros ")
], -1)
const _hoisted_4 = { class: "testimonials__list" }
const _hoisted_5 = {
  key: 0,
  class: "testimonials__item testimonials__item--text"
}
const _hoisted_6 = { class: "testimonials__person" }
const _hoisted_7 = { class: "testimonials__person--picture" }
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "testimonials__person--info" }
const _hoisted_10 = { class: "testimonials__person--h4" }
const _hoisted_11 = { class: "testimonials__person--p" }
const _hoisted_12 = { class: "testimonials__content" }
const _hoisted_13 = { class: "testimonials__content--p" }
const _hoisted_14 = {
  key: 1,
  class: "testimonials__item testimonials__item--video"
}
const _hoisted_15 = { class: "testimonials__person" }
const _hoisted_16 = { class: "testimonials__person--picture" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "testimonials__person--info" }
const _hoisted_19 = { class: "testimonials__person--h4" }
const _hoisted_20 = { class: "testimonials__person--p" }
const _hoisted_21 = { class: "testimonials__content" }
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 2,
  class: "testimonials__item testimonials__item--video testimonial__video--9-16"
}
const _hoisted_24 = { class: "testimonials__person" }
const _hoisted_25 = { class: "testimonials__person--picture" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "testimonials__person--info" }
const _hoisted_28 = { class: "testimonials__person--h4" }
const _hoisted_29 = { class: "testimonials__person--p" }
const _hoisted_30 = { class: "testimonials__content" }
const _hoisted_31 = ["src"]
const _hoisted_32 = {
  key: 3,
  class: "testimonials__item testimonials__item--audio"
}
const _hoisted_33 = { class: "testimonials__person" }
const _hoisted_34 = { class: "testimonials__person--picture" }
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "testimonials__person--info" }
const _hoisted_37 = { class: "testimonials__person--h4" }
const _hoisted_38 = { class: "testimonials__person--p" }
const _hoisted_39 = { class: "testimonials__content" }
const _hoisted_40 = { class: "audio-player" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("div", { class: "audio-player__play-pause-button" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "ri-play-large-fill" })
], -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "audio-player__progress-bar" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "audio-player__progress" })
], -1)
const _hoisted_43 = ["src"]
const _hoisted_44 = {
  key: 4,
  class: "testimonials__item testimonials__item--img"
}
const _hoisted_45 = { class: "testimonials__person" }
const _hoisted_46 = { class: "testimonials__person--picture" }
const _hoisted_47 = ["src"]
const _hoisted_48 = { class: "testimonials__person--info" }
const _hoisted_49 = { class: "testimonials__person--h4" }
const _hoisted_50 = { class: "testimonials__person--p" }
const _hoisted_51 = ["src"]
const _hoisted_52 = /*#__PURE__*/_createElementVNode("button", {
  id: "toggleButton",
  class: "testimonials__button"
}, "Ver más", -1)

import Testimonials from '@/entities/Testimonials';
import TestimonialsService from '@/services/TestimonialsService';
import { onMounted, ref, Ref, nextTick } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TestimonailsSection',
  setup(__props) {

const testimonialsService: Ref<TestimonialsService> = ref(new TestimonialsService())
const testimonials: Ref<Testimonials[]> = ref([])

onMounted(async () => {
  await getTestimonials()
  await nextTick()
  initializeAudioPlayers()
})

const getTestimonials = async () => {
  testimonials.value = await testimonialsService.value.getTestimonials()
}

const initializeAudioPlayers = (): void => {
  document.querySelectorAll<HTMLElement>('.audio-player').forEach((player) => {
    const audio = player.querySelector<HTMLAudioElement>('.audio-player__audio');
    const playPauseButton = player.querySelector<HTMLElement>('.audio-player__play-pause-button');
    const progressBar = player.querySelector<HTMLElement>('.audio-player__progress-bar');
    const progress = player.querySelector<HTMLElement>('.audio-player__progress');

    if (!audio || !playPauseButton || !progressBar || !progress) {
      return; // Asegurarse de que todos los elementos existen antes de proceder
    }

    playPauseButton.addEventListener('click', () => {
      if (audio.paused) {
        // Pausar todos los otros reproductores de audio
          document.querySelectorAll<HTMLAudioElement>('.audio-player__audio').forEach((otherAudio) => {
            if (otherAudio !== audio) {
              otherAudio.pause();
              const otherButton = otherAudio.closest('.audio-player')?.querySelector<HTMLElement>('.audio-player__play-pause-button');
              if (otherButton) {
                otherButton.innerHTML = '<i class="ri-play-large-fill"></i>';
              }
            }
          });

        audio.play();
        playPauseButton.innerHTML = '<i class="ri-pause-large-fill"></i>';
      } else {
        audio.pause();
        playPauseButton.innerHTML = '<i class="ri-play-large-fill"></i>';
      }
    });

    audio.addEventListener('timeupdate', () => {
      const progressPercent = (audio.currentTime / audio.duration) * 100;
      progress.style.width = `${progressPercent}%`;
    });

    audio.addEventListener('ended', () => {
      playPauseButton.innerHTML = '<i class="ri-play-large-fill"></i>';
      progress.style.width = '0%';
    });
  });
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(testimonials.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", { key: index }, [
            (item.type == 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("img", {
                        class: "testimonials__person--img",
                        src: 'assets/img/testimonials/' + item.user_avatar,
                        alt: ""
                      }, null, 8, _hoisted_8)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("h4", _hoisted_10, _toDisplayString(item.name), 1),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(item.position), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("p", _hoisted_13, _toDisplayString(item.comment), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (item.type == 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("img", {
                        class: "testimonials__person--img",
                        src: 'assets/img/testimonials/' + item.user_avatar,
                        alt: ""
                      }, null, 8, _hoisted_17)
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("h4", _hoisted_19, _toDisplayString(item.name), 1),
                      _createElementVNode("p", _hoisted_20, _toDisplayString(item.position), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("iframe", {
                      class: "testimonials__content--iframe iframe-3-4",
                      src: item.video_url?.toString(),
                      title: "YouTube video player",
                      frameborder: "0",
                      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                      referrerpolicy: "strict-origin-when-cross-origin",
                      allowfullscreen: ""
                    }, null, 8, _hoisted_22)
                  ])
                ]))
              : _createCommentVNode("", true),
            (item.type == 3)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("img", {
                        class: "testimonials__person--img",
                        src: 'assets/img/testimonials/' + item.user_avatar,
                        alt: ""
                      }, null, 8, _hoisted_26)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("h4", _hoisted_28, _toDisplayString(item.name), 1),
                      _createElementVNode("p", _hoisted_29, _toDisplayString(item.position), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("iframe", {
                      class: "testimonials__content--iframe iframe-9-16",
                      src: item.video_url?.toString(),
                      title: "YouTube video player",
                      frameborder: "0",
                      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                      referrerpolicy: "strict-origin-when-cross-origin",
                      allowfullscreen: ""
                    }, null, 8, _hoisted_31)
                  ])
                ]))
              : _createCommentVNode("", true),
            (item.type == 4)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", _hoisted_33, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("img", {
                        class: "testimonials__person--img",
                        src: 'assets/img/testimonials/' + item.user_avatar,
                        alt: ""
                      }, null, 8, _hoisted_35)
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("h4", _hoisted_37, _toDisplayString(item.name), 1),
                      _createElementVNode("p", _hoisted_38, _toDisplayString(item.position), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _hoisted_41,
                      _hoisted_42,
                      _createElementVNode("audio", {
                        class: "audio-player__audio",
                        src: 'assets/audios/' + item.audio_file
                      }, null, 8, _hoisted_43)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (item.type == 5)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("img", {
                        class: "testimonials__person--img",
                        src: 'assets/img/testimonials/' + item.user_avatar,
                        alt: ""
                      }, null, 8, _hoisted_47)
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("h4", _hoisted_49, _toDisplayString(item.name), 1),
                      _createElementVNode("p", _hoisted_50, _toDisplayString(item.position), 1)
                    ])
                  ]),
                  _createElementVNode("img", {
                    class: "testimonials__img",
                    src: 'assets/img/testimonials/' + item.image_src,
                    alt: ""
                  }, null, 8, _hoisted_51)
                ]))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ]),
      _hoisted_52
    ])
  ]))
}
}

})